"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var WrtFords_exports = {};
__export(WrtFords_exports, {
  WrtFords: () => WrtFords
});
module.exports = __toCommonJS(WrtFords_exports);
var import_inventory_enums = require("@cartographerio/inventory-enums");
var import_topo_map = require("@cartographerio/topo-map");
var import_core = require("../../core/index.js");
const WrtFords = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_topo_map.unsafeMapId)("wrtFords"),
  title: "FORDs",
  layers: [
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("wrtFords"),
      title: "FORDs",
      source: (0, import_core.cartographerSourceWithDefaults)({
        layerId: (0, import_topo_map.unsafeMapLayerId)("wrtFords"),
        attribution: []
      }),
      defaultAttribute: "rainfall",
      defaultZOrder: "timestamp",
      attributes: [
        (0, import_topo_map.attributeGroup)({
          label: "Survey",
          attributes: [
            (0, import_topo_map.teamAttr)("teamId", "Team"),
            (0, import_topo_map.surveyAttr)("surveyId", "Survey"),
            (0, import_topo_map.attachmentAttr)("photographs", "Photographs"),
            (0, import_topo_map.timestampAttr)({
              attributeId: "timestamp",
              label: "Date/Time",
              buckets: "auto"
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Data",
          attributes: [
            (0, import_topo_map.stringAttr)({
              attributeId: "rainfall",
              label: "Rainfall (past 24h)",
              buckets: [
                (0, import_topo_map.lookupBucket)(
                  import_inventory_enums.WrtRainfallEnum.None,
                  import_topo_map.marker.fromColor("#0099ff"),
                  import_inventory_enums.WrtRainfallEnum.labelOf(import_inventory_enums.WrtRainfallEnum.None)
                ),
                (0, import_topo_map.lookupBucket)(
                  import_inventory_enums.WrtRainfallEnum.Light,
                  import_topo_map.marker.fromColor("#0066bb"),
                  import_inventory_enums.WrtRainfallEnum.labelOf(import_inventory_enums.WrtRainfallEnum.Light)
                ),
                (0, import_topo_map.lookupBucket)(
                  import_inventory_enums.WrtRainfallEnum.Heavy,
                  import_topo_map.marker.fromColor("#003366"),
                  import_inventory_enums.WrtRainfallEnum.labelOf(import_inventory_enums.WrtRainfallEnum.Heavy)
                )
              ]
            }),
            (0, import_topo_map.enumAttr)({
              attributeId: "landUse",
              label: "Land Use",
              enum: import_inventory_enums.WrtFordsLandUseEnum
            }),
            (0, import_topo_map.stringAttr)({
              attributeId: "flow",
              label: "Flow",
              buckets: [
                (0, import_topo_map.lookupBucket)(
                  import_inventory_enums.WrtWestcountryCsiFlowLevelEnum.Still,
                  import_topo_map.marker.fromColor("#0099ff"),
                  import_inventory_enums.WrtWestcountryCsiFlowLevelEnum.labelOf(import_inventory_enums.WrtWestcountryCsiFlowLevelEnum.Still)
                ),
                (0, import_topo_map.lookupBucket)(
                  import_inventory_enums.WrtWestcountryCsiFlowLevelEnum.Slow,
                  import_topo_map.marker.fromColor("#0077cc"),
                  import_inventory_enums.WrtWestcountryCsiFlowLevelEnum.labelOf(import_inventory_enums.WrtWestcountryCsiFlowLevelEnum.Slow)
                ),
                (0, import_topo_map.lookupBucket)(
                  import_inventory_enums.WrtWestcountryCsiFlowLevelEnum.Steady,
                  import_topo_map.marker.fromColor("#005599"),
                  import_inventory_enums.WrtWestcountryCsiFlowLevelEnum.labelOf(import_inventory_enums.WrtWestcountryCsiFlowLevelEnum.Steady)
                ),
                (0, import_topo_map.lookupBucket)(
                  import_inventory_enums.WrtWestcountryCsiFlowLevelEnum.Surging,
                  import_topo_map.marker.fromColor("#003366"),
                  import_inventory_enums.WrtWestcountryCsiFlowLevelEnum.labelOf(import_inventory_enums.WrtWestcountryCsiFlowLevelEnum.Surging)
                )
              ]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "totalDissolvedSolids",
              label: "Total dissolved solids",
              unit: "ppm",
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 100, import_topo_map.marker.fromColor("#ccc")),
                (0, import_topo_map.rangeBucket)(100, 200, import_topo_map.marker.fromColor("#bbb")),
                (0, import_topo_map.rangeBucket)(200, 300, import_topo_map.marker.fromColor("#aaa")),
                (0, import_topo_map.rangeBucket)(300, 500, import_topo_map.marker.fromColor("#999")),
                (0, import_topo_map.rangeBucket)(500, 1e3, import_topo_map.marker.fromColor("#888")),
                (0, import_topo_map.rangeBucket)(1e3, 1500, import_topo_map.marker.fromColor("#777")),
                (0, import_topo_map.rangeBucket)(1500, null, import_topo_map.marker.fromColor("#666"))
              ]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "turbidity",
              label: "Turbidity",
              unit: "NTU",
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 12, import_topo_map.marker.fromColor("#00acec"), "<12"),
                (0, import_topo_map.rangeBucket)(12, 25, import_topo_map.marker.fromColor("#00aad0"), "12-25"),
                (0, import_topo_map.rangeBucket)(25, 30, import_topo_map.marker.fromColor("#66a6a2"), "25-30"),
                (0, import_topo_map.rangeBucket)(30, 40, import_topo_map.marker.fromColor("#a9a178"), "30-40"),
                (0, import_topo_map.rangeBucket)(40, 50, import_topo_map.marker.fromColor("#dd9948"), "40-50"),
                (0, import_topo_map.rangeBucket)(50, 75, import_topo_map.marker.fromColor("#f69532"), "50-75"),
                (0, import_topo_map.rangeBucket)(75, 150, import_topo_map.marker.fromColor("#cf8033"), "75-150"),
                (0, import_topo_map.rangeBucket)(150, 240, import_topo_map.marker.fromColor("#a26730"), "150-240"),
                (0, import_topo_map.rangeBucket)(240, null, import_topo_map.marker.fromColor("#754d2c"), ">240")
              ]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "phosphate",
              label: "Phosphate",
              unit: "ppb",
              buckets: [
                (0, import_topo_map.rangeBucket)(0, 99, import_topo_map.marker.fromColor("#d0d0c5"), "0"),
                (0, import_topo_map.rangeBucket)(100, 199, import_topo_map.marker.fromColor("#a5b5ab"), "100"),
                (0, import_topo_map.rangeBucket)(200, 299, import_topo_map.marker.fromColor("#7a9797"), "200"),
                (0, import_topo_map.rangeBucket)(300, 499, import_topo_map.marker.fromColor("#5b8794"), "300"),
                (0, import_topo_map.rangeBucket)(500, 999, import_topo_map.marker.fromColor("#446a85"), "500"),
                (0, import_topo_map.rangeBucket)(1e3, 2499, import_topo_map.marker.fromColor("#224b74"), "1000"),
                (0, import_topo_map.rangeBucket)(2500, null, import_topo_map.marker.fromColor("#123164"), "2500")
              ]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "nitrate",
              label: "Nitrate",
              unit: "ppm",
              buckets: [
                (0, import_topo_map.rangeBucket)(0, 9, import_topo_map.marker.fromColor("#d2cac7"), "0"),
                (0, import_topo_map.rangeBucket)(10, 29, import_topo_map.marker.fromColor("#d1beb7"), "10"),
                (0, import_topo_map.rangeBucket)(30, 59, import_topo_map.marker.fromColor("#cfaaa7"), "30"),
                (0, import_topo_map.rangeBucket)(60, 119, import_topo_map.marker.fromColor("#c98f93"), "60"),
                (0, import_topo_map.rangeBucket)(120, 199, import_topo_map.marker.fromColor("#c5677c"), "120"),
                (0, import_topo_map.rangeBucket)(200, null, import_topo_map.marker.fromColor("#c15c6d"), "200")
              ]
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "ammonia",
              label: "Ammonia",
              unit: "ppm",
              buckets: [
                (0, import_topo_map.rangeBucket)(0, 0.49, import_topo_map.marker.fromColor("#d9cf81"), "0"),
                (0, import_topo_map.rangeBucket)(0.5, 0.99, import_topo_map.marker.fromColor("#d1ca6d"), "0.5"),
                (0, import_topo_map.rangeBucket)(1, 2.99, import_topo_map.marker.fromColor("#c2c489"), "1.0"),
                (0, import_topo_map.rangeBucket)(3, 5.99, import_topo_map.marker.fromColor("#9bb384"), "3.0"),
                (0, import_topo_map.rangeBucket)(6, null, import_topo_map.marker.fromColor("#6a9685"), "6.0")
              ]
            })
          ]
        })
      ]
    })
  ]
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  WrtFords
});
//# sourceMappingURL=WrtFords.js.map
